import { AppState } from '../root-reducer';
import { ApplicationState } from './reducers';

export const selectApplication = (state: AppState): ApplicationState => state.applicationReducer;

export const selectShowMenu = (state: AppState): boolean => selectApplication(state).showMenu;
export const selectShowMenuMobile = (state: AppState): boolean => selectApplication(state).showMenuMobile;
